/* eslint sort-keys: 0 */
import { ServiceBase } from "@app/shared";
import MappingSettings from "../projects/results/adequacy/mappingSettings";

/** Handles communication across the wire when retrieving and interacting with Mapping requests. */
export default class MappingService extends ServiceBase {

  /** Retrieves the default settings for the mapping library currently being utilized. */
  public async getDefaultSettings(): Promise<MappingSettings> {
    return await this.makeGet<MappingSettings>(`/mapping/default-settings`);
  }
}
